import React from 'react'
import { Spinner } from '../../../../../../../components'
import './AiLoadingOverlay.scss'
import { useTranslation } from 'react-i18next'

const AiLoadingOverlay = ({ isLoading }) => {
  if (!isLoading) return null
  const { t } = useTranslation()
  return (
    <div className="ai-loading-overlay">
      <div className="ai-loading-inner">
        <Spinner size="small" />
        <span className="ai-loading-text">{t('v4:enabling_ai')}</span>
      </div>
    </div>
  )
}

export default AiLoadingOverlay
